import ButtonCustom from '../../../pages/UiElements/ButtonCustom';

interface Props {
  channels: any[];
  loading?: boolean;
  onEdit: (channel: any) => void;
}

const RealtimeChannelTable = ({ channels, loading, onEdit }: Props) => {
  if (loading) {
    return (
      <div className="rounded-sm border border-stroke bg-white p-8 text-center shadow-default dark:border-strokedark dark:bg-boxdark">
        Cargando canales...
      </div>
    );
  }

  return (
    <div className="rounded-sm border border-stroke bg-white shadow-default dark:border-strokedark dark:bg-boxdark">
      <div className="overflow-x-auto">
        <table className="w-full">
          <thead>
            <tr className="border-b border-stroke dark:border-strokedark">
              <th className="px-6 py-4 text-left font-medium text-black dark:text-white">
                Código
              </th>

              <th className="px-6 py-4 text-left font-medium text-black dark:text-white">
                Nombre
              </th>

              <th className="px-6 py-4 text-left font-medium text-black dark:text-white">
                Descripción
              </th>

              <th className="px-6 py-4 text-center font-medium text-black dark:text-white">
                Estado
              </th>

              <th className="px-6 py-4 text-center font-medium text-black dark:text-white">
                Acciones
              </th>
            </tr>
          </thead>

          <tbody>
            {channels.length === 0 && (
              <tr>
                <td
                  colSpan={5}
                  className="
                    px-6
                    py-10
                    text-center
                    text-body
                    dark:text-bodydark
                  "
                >
                  No hay canales realtime registrados.
                </td>
              </tr>
            )}

            {channels.map((channel) => (
              <tr
                key={channel.id}
                className="
                  border-b
                  border-stroke
                  transition
                  hover:bg-primary
                  hover:bg-opacity-5
                  dark:border-strokedark
                "
              >
                <td className="px-6 py-5 font-medium text-black dark:text-white">
                  {channel.code}
                </td>

                <td className="px-6 py-5">{channel.name}</td>

                <td className="px-6 py-5 text-body dark:text-bodydark">
                  {channel.description || '-'}
                </td>

                <td className="px-6 py-5 text-center">
                  <span
                    className={`
                      inline-flex
                      rounded-full
                      px-3
                      py-1
                      text-xs
                      font-medium
                      ${
                        channel.enabled
                          ? 'bg-success bg-opacity-10 text-success'
                          : 'bg-danger bg-opacity-10 text-danger'
                      }
                    `}
                  >
                    {channel.enabled ? 'Activo' : 'Inactivo'}
                  </span>
                </td>

                <td className="px-6 py-5">
                  <div className="flex justify-center">
                    <ButtonCustom
                      text="Editar"
                      variant="primary"
                      size="sm"
                      onClick={() => onEdit(channel)}
                    />
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default RealtimeChannelTable;
